var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isTv)?_c('appFull'):_vm._e(),(_vm.isTv)?_c('div',{attrs:{"id":"tv-page-wrapper"}},[_c('tvApp')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }